import React, { useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import debounce from "lodash.debounce";
import "./contactbenevole.css";

// Classe pour gérer l'option de menu déroulant personnalisée
class CustomDropdown {
  constructor(quill, options) {
    this.quill = quill;
    this.options = options;
    this.container = document.createElement("span");
    this.container.classList.add("custom-dropdown");

    this.list = document.createElement("ul");
    this.list.classList.add("options-list");

    this.options.forEach((option) => {
      const listItem = document.createElement("li");
      listItem.classList.add("option-item");
      listItem.textContent = option.label;
      listItem.addEventListener("click", () => this.onItemSelect(option.value));
      this.list.appendChild(listItem);
    });

    this.container.appendChild(this.list);
    // Insérer le SVG ( les flèche) à la fin du span
    const svg = `
     <svg viewBox="0 0 18 18">
       <polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"></polygon>
       <polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"></polygon>
     </svg>
   `;
    this.container.insertAdjacentHTML("beforeend", svg);
  }

  onItemSelect(value) {
    const index = this.quill.selection.savedRange.index;
    if (index !== undefined && index !== null) {
      // Si l'index du curseur est défini, insérer le texte à cet index
      this.quill.insertText(index, `[[${value}]]`, "user");
      this.quill.setSelection(index + value.length + 4);
    } else {
      // Si l'index du curseur n'est pas défini, insérer le texte à la fin du contenu
      const insertIndex = this.quill.getLength();
      this.quill.insertText(insertIndex, `[[${value}]]`, "user");
      this.quill.setSelection(insertIndex + value.length + 4);
    }
  }

  attach(container) {
    container.appendChild(this.container);
  }
}

const CustomEditorDropdown = ({ message, setMessage }) => {
  const quillRef = useRef(null);
  const debouncedSetMessageRef = useRef(
    debounce((value) => setMessage(value), 300)
  );

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      if (quill) {
        const toolbar = quill.getModule("toolbar");
        if (toolbar) {
          const customDropdown = new CustomDropdown(quill, [
            { label: "Nom", value: "Nom" },
            { label: "Prénom", value: "Prenom" },
            { label: "E-mail", value: "Email" },
            { label: "Téléphone", value: "Telephone" },
            { label: "Les activités", value: "Les activites" },
            { label: "Titre Evenement", value: "Titre Evenement" },
            { label: "Fiche Benevole", value: "Fiche Benevole" },
            { label: "Texte Soiree Info", value: "Texte Soiree Info" },
            { label: "Signature", value: "Signature" },
            { label: "Selected Activty", value: "Selected Activty" },
            { label: "Date courrante", value: "Date" },
          ]);
          customDropdown.attach(toolbar.container);
        }
      }
    }

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      debouncedSetMessageRef.current.cancel();
    };
  }, []);

  // Fonction de gestion des changements dans l'éditeur
  const handleChange = (value) => {
    debouncedSetMessageRef.current(value);
  };

  return (
    <div className="text-editor" style={{ backgroundColor: "white" }}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={message || ""}
        onChange={handleChange}
        className="quill-editor"
      />
    </div>
  );
};

export default CustomEditorDropdown;
